import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';

import { useAuth } from '@/api';

type RequireLoggedInProps = {
  children: ReactNode;
};

/** renders children, if the User is authenticated, otherwise redirects to /login */
export const RequireLoggedIn = ({ children }: RequireLoggedInProps) => {
  const { pathname, search } = useLocation();
  const user = useAuth();

  const next = /\/\w+/.test(pathname)
    ? `?next=${pathname}${search ? encodeURIComponent(search) : ''}`
    : '';
  if (!user) return <Navigate to={`/login${next}`} replace />;

  return children;
};
